import { FC, ReactElement } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { render, RenderResult } from '@testing-library/react'
import { AppProvider, ThemeProvider, CONFIG } from '../providers'

export const dbg = {
  // eslint-disable-next-line
  log: (label: string, val: any = null) => {
    if (CONFIG?.debug) {
      if (val as boolean) {
        console.log(label, val)
      } else {
        console.log(label)
      }
    } else {
      throw new Error("using dbg without configuration");
    }
  },
  group: (label: string) => {
    if (CONFIG?.debug) {
      console.group(label)
    } else {
      throw new Error("using dbg without configuration");
    }
  },
  groupEnd: () => {
    if (CONFIG?.debug) {
      console.groupEnd()
    } else {
      throw new Error("using dbg without configuration");
    }
  },
}

export const RouterWrapper: FC<{
  children: ReactElement | ReactElement[]
}> = ({ children }) => {
  return <BrowserRouter>{children}</BrowserRouter>
}

export const ConfigWrapper: FC<{
  children: ReactElement | ReactElement[]
}> = ({ children }) => {
  return (
    <ThemeProvider>
      <RouterWrapper>{children}</RouterWrapper>
    </ThemeProvider>
  )
}

export const AppWrapper: FC<{
  children: ReactElement | ReactElement[]
}> = ({ children }) => {
  return (
    <AppProvider>
      <RouterWrapper>{children}</RouterWrapper>
    </AppProvider>
  )
}

export const customRender = (componenet: ReactElement): RenderResult => {
  return render(componenet, { wrapper: ConfigWrapper })
}

export * from './mockAPI.utils'
export * from './date.utils'
